import React, { Component, ErrorInfo, ReactNode } from "react";
import { Box, Button, Typography, Stack } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            p: 3,
          }}
        >
          <Stack spacing={2} alignItems="center" sx={{ maxWidth: 500 }}>
            <ErrorOutlineIcon sx={{ fontSize: 64, color: "error.main" }} />
            <Typography variant="h5" textAlign="center">
              Algo deu errado
            </Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Ocorreu um erro inesperado. Tente recarregar a página.
            </Typography>
            <Button variant="contained" onClick={this.handleReload}>
              Recarregar
            </Button>
          </Stack>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
